import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { AuthService } from '../../_services';
import { LoaderService } from '../../_services/loader.service';
import { process, State, aggregateBy } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { Observable } from 'rxjs/Observable';
import { SelectableSettings, DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;
import { utils, write, WorkBook } from 'xlsx';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';


// pie chart
import { LegendLabelsContentArgs } from "@progress/kendo-angular-charts";
import { IntlService } from "@progress/kendo-angular-intl"
//pie chart


declare var $: any;
const distinctPurchase = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.PURCHASETYPE === x.PURCHASETYPE) === idx);
const distinctZone = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.Zone === x.Zone) === idx);

const distinctWard = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.ward === x.ward) === idx);

const distinctVehCategory = (data) =>
	data.filter((x, idx, xs) => xs.findIndex((y) => y.vehcatName === x.vehcatName) === idx);

export const MY_FORMATS = {
	parse: {
		dateInput: 'LL'
	},
	display: {
		dateInput: 'LL',
		monthYearLabel: 'MMM YYYY',
		dateA11yLabel: 'LL',
		monthYearA11yLabel: 'MMMM YYYY'
	}
};

@Component({
	selector: 'graphical',
	templateUrl: './graphicalView.component.html'
})

export class GraphicalVievComponent {
	prjId: any;
	showLoader: boolean;
	startDate: any;
	endDate: any;
	defStartDt: any;
	defEndDt: any;
	dateRange: any;
	fuelReportList: any;
	purchaseImg: any;
	fuelAmnt: any;
	fuelQty: any;
	rowCount: any;
	public pieData: any;
	public state: State = {
		skip: 0,
		take: 16,
		filter: {
			logic: 'and',
			filters: []
		}
	};
	public pageSize: any;
	public checkboxOnly = false;
	public mode = 'multiple';
	public selectableSettings: SelectableSettings;
	public masterdata: any;
	gridDatamaster: DataResult;

	public allData(): ExcelExportData {
		const result: ExcelExportData = {
			data: this.masterdata 
		};
		return result;
	}

	public groups: GroupDescriptor[] = [];
	public view: Observable<GridDataResult>;

	public gridDataFuelReport: DataResult;
	public groupChange(groups: GroupDescriptor[]): void {
		this.groups = groups;
		this.loadProducts();
	}
	
	public distinctPurchase: any[];
	public distinctVehCategory: any[];
	public distinctZone: any[];
	public distinctWard: any[];
	public distinctVehType: any[];
	loaderClass: any;
	syncing: any;
	private loadProducts(): void {
		this.gridDataFuelReport = process(this.fuelReportList, { group: this.groups });
	}
	constructor(
		private http: HttpClient,
		private auth: AuthService,
		public routes: ActivatedRoute,
		public router: Router,
		private loaderService: LoaderService,
		private intl: IntlService
	) {
		this.loaderService.status.subscribe((val: boolean) => {
			this.showLoader = val;
		});
		this.allData = this.allData.bind(this);
		var date = new Date();
		this.defStartDt = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
		this.defEndDt = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
		this.dateRange = {
			beginDate: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() },
			endDate: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() }
		};
		this.fuelAmnt = 0;
		this.fuelQty = 0;
		this.rowCount = 0;
		//this.labelContent = this.labelContent.bind(this);
	}


	ngOnInit() {  
        this.startDate = moment(this.defStartDt).format('YYYY-MM-DD');
        this.endDate= moment(this.defEndDt).format('YYYY-MM-DD');
        this.prjId = this.auth.getAuthentication().projectId  ;

		console.log(this.prjId);
		
        this.getFuelMasterRepoerList();
    } 


	getFuelMasterRepoerList() {
		this.loaderService.display(true); 
		console.log(this.prjId);
		//   api to get all master data start 
		this.http.get(environment.apiUrl + 'reports/graphReport?prjid='+this.prjId+'&startDate='+this.startDate+'&endDate='+this.endDate).subscribe(data =>{ 
			this.pieData=data;

            console.log('151',this.pieData);
			

			if(this.pieData.length>0){  
				//this.distinctLocation = distinctLocation(this.fuelDistList) 
				//this.distinctFuelType = distinctFuelType(this.fuelDistList)
				// this.distinctVehCategory = distinctVehCategory(this.masterdata);
		        // this.distinctZone = distinctZone(this.masterdata) 
				// this.distinctWard = distinctWard(this.masterdata) 
				// this.distinctPurchase = distinctPurchase(this.masterdata)        
				// this.gridDatamaster = process(this.masterdata, this.state);
				 this.loaderService.display(false); 
			}else{
				this.loaderService.display(false); 
				this.gridDatamaster=null;
			} 
             
			
		
		});  


	


		//   api to get all master data start 



		
	}

	


	//// excell down load data 

	importVehiclesExcelReport(data) {
		const ws_name = 'VehicleReport';
		const wb: WorkBook = { SheetNames: [], Sheets: {} };
		const ws: any = utils.json_to_sheet(data);
		wb.SheetNames.push(ws_name);
		wb.Sheets[ws_name] = ws;
		const wbout = write(wb, {
		  bookType: 'xlsx', bookSST: true, type:
			'binary'
		});
		saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'exported.xlsx');
	  }
	
	  s2ab(s) {
		const buf = new ArrayBuffer(s.length);
		const view = new Uint8Array(buf);
		for (let i = 0; i !== s.length; ++i) {
		  view[i] = s.charCodeAt(i) & 0xFF;
		};
		return buf;
	  }



	  onDateRangeChanged(dataRange)
	  {  
		if(dataRange.beginDate.day>0){ 
		  this.startDate= dataRange.beginDate.year + "-"  + dataRange.beginDate.month+ "-" + dataRange.beginDate.day 
		  this.endDate = dataRange.endDate.year + "-"  + dataRange.endDate.month  + "-" + dataRange.endDate.day 
		  this.getFuelMasterRepoerList(); 
		}
		else if(dataRange.beginDate.day==0){
		  this.startDate= this.defStartDt
		  this.endDate = this.defEndDt
		  this.getFuelMasterRepoerList(); 
		}  
	  }  



	  /*
 * filter The Grid Data
*/
  public dataStateChange(state: DataStateChangeEvent): void {
	this.state = state;
	//this.gridDataFuelDist = process(this.masterdata  , this.state);  
	if (state && state.group) { 
		this.distinctVehCategory = distinctVehCategory(this.masterdata);
		this.distinctZone = distinctZone(this.masterdata)
		this.distinctPurchase = distinctPurchase(this.masterdata)     
		this.gridDatamaster = process(this.masterdata, this.state); 
	  } 
  } 

 

// public pieData: any[] = [
//     { category: "Purchased", value: 745 },
//     { category: "Distributed", value: 648 }
    
//   ];



//   public labelContent(args: LegendLabelsContentArgs): string {
//     return `${args.dataItem.category} ${this.intl.formatNumber(
//       args.dataItem.value,'p2'
//     )}`;

	
  




//   pie char code start end 






}


// WEBPACK FOOTER //
// ./src/app/reports/fuel/graphicalView.component.ts